import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=d44ca22c&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44ca22c",
  null
  
)

export default component.exports